import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-tooltip-icon',
  imports: [TooltipModule, NgClass],
  templateUrl: './tooltip-icon.component.html',
  styleUrl: './tooltip-icon.component.scss',
  standalone: true,
})
export class TooltipIconComponent {
  @Input() position: string = 'top';
  @Input() message: string = '';
  @Input() iconClass: string = 'text-greyscale-500';
}
